import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-you-badge-component',
  template: `<span class="badge bg-warning">{{'general.typeahead.you'| transloco}}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YouBadgeComponentComponent {
}
